<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Vetos</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-form-field>
            <mat-label>Search</mat-label>
            <input matInput (keyup)="searchVeto($event)">
        </mat-form-field>
        <table mat-table class="transparent-table" [dataSource]="vetoSource" matSort >
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let veto">
                    {{ veto.date | date:'dd.MM.yyyy' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="competition">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Competition</th>
                <td mat-cell *matCellDef="let veto">
                    {{ getCompetitionName(veto.competition) }}
                </td>
            </ng-container>
            <ng-container matColumnDef="match">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Match</th>
                <td mat-cell *matCellDef="let veto">
                    {{ getTeamTricode(veto.teamOne) }} vs {{ getTeamTricode(veto.teamTwo) }}
                </td>
            </ng-container>
            <ng-container matColumnDef="concluded">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let veto">
                    <ng-container *ngIf="veto.concluded">
                        <span>Concluded ({{ veto.concluded | date:'dd.MM.yyyy - HH:mm' }})</span>
                    </ng-container>
                    <ng-container *ngIf="!veto.concluded">
                        <span><mat-icon matTooltip="Join Veto" (click)="goToLobby(veto.lobbyCode)" >open_in_new</mat-icon> Lobby: {{ veto.lobbyCode }}</span>
                    </ng-container>
                </td>
            </ng-container>
            <ng-container matColumnDef="info">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let veto">
                    <mat-icon matTooltip="Show Veto" (click)="showVetoInfo(veto)">info_outline</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let veto">
                    <mat-spinner *ngIf="veto.uid == isDeleteVeto"></mat-spinner>
                    <mat-icon matTooltip="Delete Veto" *ngIf="veto.uid != isDeleteVeto" (click)="deleteVeto(veto)">delete_outline</mat-icon>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator class="transparent-paginator" [pageSizeOptions]="[25, 50, 100, 200, 500]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
</mat-card>